import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor() {}

  setLang(lang) { localStorage.setItem('lang', lang) }
  setDashboardFilter(filters) { localStorage.setItem('dashboardFilters', JSON.stringify(filters)) }
  setCompanyLang(lang) { localStorage.setItem('companyLang', lang) }

  resetCache() {
    localStorage.removeItem('lang')
    localStorage.removeItem('dashboardFilters')
    localStorage.removeItem('companyLang')
  }

  get(key, obj?) {
    if (obj) return JSON.parse(localStorage.getItem(key)) || null;
    return localStorage.getItem(key) || null;
  }
}
